module.exports = __webpack_public_path__ + "img/close-white.9bf79cb8.svg";